
import { User } from 'lucide-react';

type TeamMemberProps = {
  name: string;
  role: string;
  status: 'great' | 'good' | 'okay' | 'low' | 'struggling';
  imageSrc?: string;
};

const getStatusIndicator = (status: TeamMemberProps['status']) => {
  const baseClasses = "w-3 h-3 rounded-full";
  
  const statusClasses = {
    great: "bg-green-400",
    good: "bg-emerald-400",
    okay: "bg-blue-400",
    low: "bg-amber-400",
    struggling: "bg-red-400"
  };
  
  return <div className={`${baseClasses} ${statusClasses[status]}`}></div>;
};

const TeamMember = ({ name, role, status, imageSrc }: TeamMemberProps) => {
  return (
    <div className="flex items-center gap-3 p-3 hover:bg-muted/50 rounded-lg transition-colors">
      <div className="relative">
        {imageSrc ? (
          <img src={imageSrc} alt={name} className="w-10 h-10 rounded-full object-cover" />
        ) : (
          <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center text-muted-foreground">
            <User size={20} />
          </div>
        )}
        <div className="absolute -bottom-1 -right-1">{getStatusIndicator(status)}</div>
      </div>
      <div>
        <p className="font-medium">{name}</p>
        <p className="text-sm text-muted-foreground">{role}</p>
      </div>
    </div>
  );
};

export default TeamMember;
